const storageKey = (state: string) => `controls-list-search:${state}`;

export const saveControlsListSearch = (state: string, search: string) => {
  sessionStorage.setItem(storageKey(state), search);
};

export const buildControlsListPath = (state: string) => {
  const search = sessionStorage.getItem(storageKey(state));
  return search ? `/kontroller/${state}?${search}` : `/kontroller/${state}`;
};
